import React, { Component } from 'react';
import config from 'react-global-configuration';

// Import Router
import { BrowserRouter, Route, Switch } from 'react-router-dom';
//Import globals
import Globals from './Components/Miscelania/Globals';

/**
 * Architecture
 */
// Users
import EmailTrainingAttendenceConfirmation from './Components/Users/EmailTrainingAttendenceConfirmation';
import EmailTrainingAvaliation from './Components/Users/EmailTrainingAvaliation';
import Login from './Components/Users/Login';
import RecuperarSenha from './Components/Users/RecuperarSenha';
import Suspenso from './Components/Users/Suspenso';
import UsersEditPassword from './Components/Users/UsersEditPassword';
import UsersEdit from './Components/Users/UsersEdit';
import UsersIndex from './Components/Users/UsersIndex';
import UsersAdd from './Components/Users/UsersAdd';

// Emails
import EmailsEdit from './Components/Emails/EmailsEdit';
import EmailsIndex from './Components/Emails/EmailsIndex';

// Logs
import LogsIndex from './Components/Logs/LogsIndex';
// Import
import ImportIndex from './Components/Import/ImportIndex';
/**
 * Content
 */

// Absences
import AbsencesIndex from './Components/Absences/AbsencesIndex';
import AbsencesAdd from './Components/Absences/AbsencesAdd';
import AbsencesEdit from './Components/Absences/AbsencesEdit';

// AircraftModel
import AircraftsIndex from './Components/Aircrafts/AircraftsIndex';
import AircraftsAdd from './Components/Aircrafts/AircraftsAdd';
import AircraftsEdit from './Components/Aircrafts/AircraftsEdit';

// AircraftModels
import AircraftModelsIndex from './Components/AircraftModels/AircraftModelsIndex';
import AircraftModelsAdd from './Components/AircraftModels/AircraftModelsAdd';
import AircraftModelsEdit from './Components/AircraftModels/AircraftModelsEdit';

// Bases
import BasesIndex from './Components/Bases/BasesIndex';
import BasesAdd from './Components/Bases/BasesAdd';
import BasesEdit from './Components/Bases/BasesEdit';

// Signatures
import SignaturesIndex from './Components/Signatures/SignaturesIndex';
import SignaturesAdd from './Components/Signatures/SignaturesAdd';
import SignaturesEdit from './Components/Signatures/SignaturesEdit';

// GroupCertifications
import CertificationGroupsIndex from './Components/CertificationGroups/CertificationGroupsIndex';
import CertificationGroupsAdd from './Components/CertificationGroups/CertificationGroupsAdd';
import CertificationGroupsEdit from './Components/CertificationGroups/CertificationGroupsEdit';

// Certifications
import CertificationsCompleteIndex from './Components/Certifications/CertificationsCompleteIndex';
import CertificationsIndex from './Components/Certifications/CertificationsIndex';
import CertificationsIndexDeprecated from './Components/Certifications/CertificationsIndexDeprecated';
import CertificationsAdd from './Components/Certifications/CertificationsAdd';
import CertificationsEdit from './Components/Certifications/CertificationsEdit';

// Designations
import DesignationsIndex from './Components/Designations/DesignationsIndex';
import DesignationsAdd from './Components/Designations/DesignationsAdd';
import DesignationsEdit from './Components/Designations/DesignationsEdit';

// Manufacturers
import ManufacturersIndex from './Components/Manufacturers/ManufacturersIndex';
import ManufacturersAdd from './Components/Manufacturers/ManufacturersAdd';
import ManufacturersEdit from './Components/Manufacturers/ManufacturersEdit';

// Ojts
import OjtsIndex from './Components/Ojts/OjtsIndex';
import OjtsAdd from './Components/Ojts/OjtsAdd';
import OjtsEdit from './Components/Ojts/OjtsEdit';

// Plannings
import PlanningsAdd from './Components/Plannings/PlanningsAdd';
import PlanningsAddVacations from './Components/Plannings/PlanningsAddVacations';
import PlanningsIndexVacations from './Components/Plannings/PlanningsIndexVacations';
import PlanningsEdit from './Components/Plannings/PlanningsEdit';
import PlanningsEditVacations from './Components/Plannings/PlanningsEditVacations';
import PlanningVacationStaffsChange from './Components/PlanningVacationStaffs/PlanningVacationStaffsChange';
import PlanningVacationStaffsConfirmation from './Components/PlanningVacationStaffs/PlanningVacationStaffsConfirmation';

// Posts
import PostsIndex from './Components/Posts/PostsIndex';
import PostsAdd from './Components/Posts/PostsAdd';
import PostsEdit from './Components/Posts/PostsEdit';

// References
import ReferencesIndex from './Components/References/ReferencesIndex';
import ReferencesAdd from './Components/References/ReferencesAdd';
import ReferencesEdit from './Components/References/ReferencesEdit';

// Regimes
import RegimesIndex from './Components/Regimes/RegimesIndex';
import RegimesAdd from './Components/Regimes/RegimesAdd';
import RegimesEdit from './Components/Regimes/RegimesEdit';

// Roles
import RolesIndex from './Components/Roles/RolesIndex';
import RolesAdd from './Components/Roles/RolesAdd';
import RolesEdit from './Components/Roles/RolesEdit';
// RoleGroupCertifications
import RoleGroupCertificationsIndex from './Components/RoleGroupCertifications/RoleGroupCertificationsIndex';

// Schedules
import SchedulesAdd from './Components/Schedules/SchedulesAdd';
import SchedulesChangeSimulation from './Components/Schedules/SchedulesChangeSimulation';
import SchedulesElaborate from './Components/Schedules/SchedulesElaborate';
import SchedulesEdit from './Components/Schedules/SchedulesEdit';
import SchedulesIndex from './Components/Schedules/SchedulesIndex';
import SchedulesDuplicate from './Components/Schedules/SchedulesDuplicate';
import SchedulesUnified from './Components/Schedules/SchedulesUnified';

// SchedulePendencies
import ScheduleRequestsIndex from './Components/ScheduleRequests/ScheduleRequestsIndex';
// SchedulePendencies
import SchedulePendenciesIndex from './Components/SchedulePendencies/SchedulePendenciesIndex';
import SchedulePendenciesPending from './Components/SchedulePendencies/SchedulePendenciesPending';

// ScheduleTrades
import ScheduleTradesAdd from './Components/ScheduleTrades/ScheduleTradesAdd';
import ScheduleTradesIndex from './Components/ScheduleTrades/ScheduleTradesIndex';
import ScheduleTradesPending from './Components/ScheduleTrades/ScheduleTradesPending';
import ScheduleTradeResponsibleEmails from './Components/ScheduleTrades/ScheduleTradeResponsibleEmails';

// ScheduleGrades
import ScheduleGradesEdit from './Components/ScheduleGrades/ScheduleGradesEdit';
import ScheduleGradesExpirationsControl from './Components/ScheduleGrades/ScheduleGradesExpirationsControl';

// Staffs
import StaffsWithoutDesignations from './Components/Staffs/StaffsWithoutDesignations';
import StaffsFullSearch from './Components/Staffs/StaffsFullSearch';
import ExpireItensStaffDesignations from './Components/StaffDesignations/ExpireItensStaffDesignations';
import StaffsPromotionsIndex from './Components/Staffs/StaffsPromotionsIndex';
import StaffsIndex from './Components/Staffs/StaffsIndex';
import StaffsIndexCmdts from './Components/Staffs/StaffsIndexCmdts';
import StaffsIndexFull from './Components/Staffs/StaffsIndexFull';
import StaffsByDesignationIndex from './Components/Staffs/StaffsByDesignationIndex';
import StaffsIndexCnh from './Components/Staffs/StaffsIndexCnh';
import StaffsIndexAso from './Components/Staffs/StaffsIndexAso';
import StaffsIndexTaskCards from './Components/Staffs/StaffsIndexTaskCards';
import SuspendedStaffAircraftModels from './Components/Staffs/SuspendedStaffAircraftModels';
import StaffsControlTaskCards from './Components/Staffs/StaffsControlTaskCards';
import StaffsIndexTransfered from './Components/Staffs/StaffsIndexTransfered';
import StaffsIndexContracted from './Components/Staffs/StaffsIndexContracted';
import StaffsIndexFired from './Components/Staffs/StaffsIndexFired';
import StaffsAdd from './Components/Staffs/StaffsAdd';
import StaffsEdit from './Components/Staffs/StaffsEdit';

// StaffAircraftModels
import StaffAircraftModelsIndex from './Components/StaffAircraftModels/StaffAircraftModelsIndex';
import StaffAircraftModelsWithoutCertificationsIndex from './Components/StaffAircraftModels/StaffAircraftModelsWithoutCertificationsIndex';
// StaffBases
import StaffBasesIndex from './Components/StaffBases/StaffBasesIndex';

// StaffCertifications
import StaffCertificationsEdit from './Components/StaffCertifications/StaffCertificationsEdit';
import StaffCertificationsArchiveIndex from './Components/StaffCertifications/StaffCertificationsArchiveIndex';
import StaffCertificationsIndex from './Components/StaffCertifications/StaffCertificationsIndex';
import StaffsCerficationsMultipleFilter from './Components/StaffCertifications/StaffsCerficationsMultipleFilter';
import StaffsCerficationsByRolesIndex from './Components/StaffCertifications/StaffsCerficationsByRolesIndex';
import StaffsCerficationsByDesignationsIndex from './Components/StaffCertifications/StaffsCerficationsByDesignationsIndex';
import StaffsCerficationsOutdatedIndex from './Components/StaffCertifications/StaffsCerficationsOutdatedIndex';
import StaffCertificationsResults from './Components/StaffCertifications/StaffCertificationsResults';

//StaffCertificationPendencies
import StaffCertificationPendenciesIndex from './Components/StaffCertificationPendencies/StaffCertificationPendenciesIndex';

// StaffChecks
import StaffChecksIndex from './Components/StaffChecks/StaffChecksIndex';
// StaffDesignations
import StaffDesignationsControl from './Components/StaffDesignations/StaffDesignationsControl';
import StaffDesignationsPending from './Components/StaffDesignations/StaffDesignationsPending';
import StaffDesignationsIndex from './Components/StaffDesignations/StaffDesignationsIndex';
// StaffFleets
import StaffFleetsIndex from './Components/StaffFleets/StaffFleetsIndex';
import StaffWithoutFleetsIndex from './Components/StaffFleets/StaffWithoutFleetsIndex';

// StaffJobTrainings
import StaffJobTrainingsIndex from './Components/StaffJobTrainings/StaffJobTrainingsIndex';

// StaffLicenses
import StaffLicensesIndex from './Components/StaffLicenses/StaffLicensesIndex';

// StaffLanguages
import StaffLanguagesIndex from './Components/StaffLanguages/StaffLanguagesIndex';


// StaffOjts
import StaffOjtsActualSearch from './Components/StaffOjts/StaffOjtsActualSearch';
import StaffOjtsAdd from './Components/StaffOjts/StaffOjtsAdd';
import StaffOjtsEdit from './Components/StaffOjts/StaffOjtsEdit';
import StaffOjtsApprove from './Components/StaffOjts/StaffOjtsApprove';
import StaffOjtsIndex from './Components/StaffOjts/StaffOjtsIndex';
import StaffOjtsSearch from './Components/StaffOjts/StaffOjtsSearch';
import StaffOjtsSearchDone from './Components/StaffOjts/StaffOjtsSearchDone';
import StaffOjtsSearchToDo from './Components/StaffOjts/StaffOjtsSearchToDo';


// StaffsCerficationsConsolidated
import StaffCerficationsConsolidated from './Components/StaffCertifications/StaffCerficationsConsolidated';

// StaffRevisions
import StaffRevisionsIndex from './Components/StaffRevisions/StaffRevisionsIndex';

// StaffStamps
import StaffStampsIndex from './Components/StaffStamps/StaffStampsIndex';


// Suppliers
import SuppliersIndex from './Components/Suppliers/SuppliersIndex';
import SuppliersEdit from './Components/Suppliers/SuppliersEdit';
import SuppliersAdd from './Components/Suppliers/SuppliersAdd';

// Tasks
import TasksIndex from './Components/Tasks/TasksIndex';
import TasksAdd from './Components/Tasks/TasksAdd';
import TasksEdit from './Components/Tasks/TasksEdit';

// Trainings
import TrainingsByCertificationIndex from './Components/Trainings/TrainingsByCertificationIndex';
import TrainingsIndex from './Components/Trainings/TrainingsIndex';
import TrainingsAdd from './Components/Trainings/TrainingsAdd';
import TrainingsEdit from './Components/Trainings/TrainingsEdit';

// TrainingCertificationStaffs
import TrainingCertificationStaffControl from './Components/TrainingCertificationStaffs/TrainingCertificationStaffControl';
import TrainingCertificationStaffsIndex from './Components/TrainingCertificationStaffs/TrainingCertificationStaffsIndex';
import TrainingCertificationStaffsIndexExpected from './Components/TrainingCertificationStaffs/TrainingCertificationStaffsIndexExpected';

// TrainingCertificationStaffPayments
import PaymentHoursAdd from './Components/TrainingCertificationStaffPayments/PaymentHoursAdd';
import PaymentDailyAdd from './Components/TrainingCertificationStaffPayments/PaymentDailyAdd';
import PaymentExtraAdd from './Components/TrainingCertificationStaffPayments/PaymentExtraAdd';
import PaymentDailyInternationalAdd from './Components/TrainingCertificationStaffPayments/PaymentDailyInternationalAdd';
import PaymentHoursOpened from './Components/TrainingCertificationStaffPayments/PaymentHoursOpened';
import PaymentDailyOpened from './Components/TrainingCertificationStaffPayments/PaymentDailyOpened';
import PaymentExtraOpened from './Components/TrainingCertificationStaffPayments/PaymentExtraOpened';
import PaymentCheckOpened from './Components/TrainingCertificationStaffPayments/PaymentCheckOpened';
import StaffDebt from './Components/TrainingCertificationStaffPayments/StaffDebt';
import PaymentDebtAdd from './Components/TrainingCertificationStaffPayments/PaymentDebtAdd';
import PaymentDebtEdit from './Components/TrainingCertificationStaffPayments/PaymentDebtEdit';
import PaymentCreditAdd from './Components/TrainingCertificationStaffPayments/PaymentCreditAdd';
import PaymentCreditEdit from './Components/TrainingCertificationStaffPayments/PaymentCreditEdit';

// SchedulePayments
import SchedulePaymentHoursAdd from './Components/SchedulePayments/PaymentHoursAdd';
import SchedulePaymentDailyAdd from './Components/SchedulePayments/PaymentDailyAdd';
import SchedulePaymentDistanceAdd from './Components/SchedulePayments/PaymentDistanceAdd';
import SchedulePaymentTransportAdd from './Components/SchedulePayments/PaymentTransportAdd';
import SchedulePaymentExtraAdd from './Components/SchedulePayments/PaymentExtraAdd';
import SchedulePaymentDailyBaseAdd from './Components/SchedulePayments/PaymentDailyBaseAdd';
import SchedulePaymentHoursOpened from './Components/SchedulePayments/PaymentHoursOpened';
import SchedulePaymentDailyOpened from './Components/SchedulePayments/PaymentDailyOpened';
import SchedulePaymentBaseChiefOpened from './Components/SchedulePayments/PaymentBaseChiefOpened';
import SchedulePaymentDistanceOpened from './Components/SchedulePayments/PaymentDistanceOpened';
import SchedulePaymentTransportOpened from './Components/SchedulePayments/PaymentTransportOpened';
import SchedulePaymentExtraOpened from './Components/SchedulePayments/PaymentExtraOpened';

import PaymentRequestTrainingDistanceIndex from './Components/PaymentRequests/PaymentRequestTrainingDistanceIndex';
import PaymentRequestTrainingTransportIndex from './Components/PaymentRequests/PaymentRequestTrainingTransportIndex';

//PaymentOrders
import PaymentOrdersAdd from './Components/PaymentOrders/PaymentOrdersAdd';
import PaymentOrdersEdit from './Components/PaymentOrders/PaymentOrdersEdit';
import PaymentOrdersSentIndex from './Components/PaymentOrders/PaymentOrdersSentIndex';
import PaymentOrdersOpenedIndex from './Components/PaymentOrders/PaymentOrdersOpenedIndex';

import PaymentValuesEdit from './Components/PaymentValues/PaymentValuesEdit';

import StaffRevisionDesignationRepairEmail from './Components/StaffRevisionDesignations/StaffRevisionDesignationRepairEmail';
import StaffRevisionDesignationResponsiblesEmail from './Components/StaffRevisionDesignations/StaffRevisionDesignationResponsiblesEmail';
import StaffRevisionDesignationEmail from './Components/StaffRevisionDesignations/StaffRevisionDesignationEmail';
import StaffRevisionDesignationsIndex from './Components/StaffRevisionDesignations/StaffRevisionDesignationsIndex';



class App extends Component {
  // constructor
  constructor(props, context) {
    super(props, context);

    this.state = {
      permission: false,
    }

  }
    componentDidMount() {
        var url_login = config.get('url') + '/usuario/login';
        var url_suspended = config.get('url') + '/usuario/suspenso';
        var url_recovery_pw = config.get('url') + '/usuario/recuperar_senha';
        var url_email_token = 'email/confirmacao';
        var url_email_token_revision = 'revisao/designacao';
        var url_email_token_schedule_trade = 'solicitacao/colaborador';
        var url_actual = window.location.href;

        if(url_actual !== url_login && url_actual !== url_suspended && url_actual !== url_recovery_pw && !url_actual.includes(url_email_token) && !url_actual.includes(url_email_token_revision) && !url_actual.includes(url_email_token_schedule_trade)) {
          // busco as infos
          var params = JSON.parse(localStorage.getItem("cid"));
          // Verifico se há algum storage setado
          if(params === null || typeof params === 'undefined') {
            window.location.replace(config.get('url') + '/usuario/login');
          } else {
            // Verifico se o cid acode setado
            if(params.acode === null || typeof params.acode === 'undefined') {
              window.location.replace(config.get('url') + '/usuario/login');
            } else {
              this.setState({permission: true});
            }
          }
        } else {
          this.setState({permission: true});
        }
    }

  render() {
    return (
      <div>
        {
          (this.state.permission === false) ? '' :
            <div>
              <BrowserRouter>
                <Switch>
                  {/* Tela inicial */}
                  <Route path="/solicitacao/colaborador/:token" component={ScheduleTradeResponsibleEmails} />
                  <Route path="/email/confirmacao/:token" component={EmailTrainingAttendenceConfirmation} />
                  <Route path="/avaliacao/treinamento/:token" component={EmailTrainingAvaliation} />
                  <Route path="/usuario/login" component={Login} />
                  <Route path="/usuario/suspenso" component={Suspenso} />
                  {/* Email*/}
                  <Route path="/email/editar/:id" component={EmailsEdit} />
                  <Route path="/emails" component={EmailsIndex} />
                  {/* Log*/}
                  <Route path="/logs" component={LogsIndex} />
                  {/* Importações*/}
                  <Route path="/importacoes" component={ImportIndex} />
                  {/* User*/}
                  <Route path="/usuario/editar/:id" component={UsersEdit} />
                  <Route path="/usuarios" component={UsersIndex} />
                  {/* Absences */}
                  <Route path="/afastamento/cadastrar" component={AbsencesAdd} />
                  <Route path="/afastamento/:id" component={AbsencesEdit} />
                  <Route path="/afastamentos" component={AbsencesIndex} />
                  {/* Aircrafts */}
                  <Route path="/aeronave/cadastrar" component={AircraftsAdd} />
                  <Route path="/aeronave/:id" component={AircraftsEdit} />
                  <Route path="/aeronaves" component={AircraftsIndex} />
                  {/* AircraftModels */}
                  <Route path="/frota/cadastrar" component={AircraftModelsAdd} />
                  <Route path="/frota/:id" component={AircraftModelsEdit} />
                  <Route path="/frotas" component={AircraftModelsIndex} />
                  {/* Bases */}
                  <Route path="/base/cadastrar" component={BasesAdd} />
                  <Route path="/base/:id" component={BasesEdit} />
                  <Route path="/bases" component={BasesIndex} />
                  {/* Signatures */}
                  <Route path="/assinatura/cadastrar" component={SignaturesAdd} />
                  <Route path="/assinatura/:id" component={SignaturesEdit} />
                  <Route path="/assinaturas" component={SignaturesIndex} />
                  {/* GroupCertifications */}
                  <Route path="/agrupamento/certificados/cadastrar" component={CertificationGroupsAdd} />
                  <Route path="/agrupamento/certificados/:id" component={CertificationGroupsEdit} />
                  <Route path="/agrupamento/certificados" component={CertificationGroupsIndex} />
                  {/* StaffCertificationPendencies */}
                  <Route path="/certificados/pendentes" component={StaffCertificationPendenciesIndex} />
                  {/* Certification */}
                  <Route path="/certificados/geral" component={CertificationsCompleteIndex} />
                  <Route path="/certificado/cadastrar" component={CertificationsAdd} />
                  <Route path="/certificado/editar/:id" component={CertificationsEdit} />
                  <Route path="/certificados/defasados" component={CertificationsIndexDeprecated} />
                  <Route path="/certificados" component={CertificationsIndex} />
                  {/* Designations */}
                  <Route path="/designacao/cadastrar" component={DesignationsAdd} />
                  <Route path="/designacao/:id" component={DesignationsEdit} />
                  <Route path="/designacoes" component={DesignationsIndex} />
                  {/* Manufacturers */}
                  <Route path="/fabricante/cadastrar" component={ManufacturersAdd} />
                  <Route path="/fabricante/:id" component={ManufacturersEdit} />
                  <Route path="/fabricantes" component={ManufacturersIndex} />
                  {/* Ojts */}
                  <Route path="/ojts/aprovar" component={StaffOjtsApprove} />
                  <Route path="/ojts/finalizados" component={StaffOjtsIndex} />
                  <Route path="/controle/ojt/base" component={StaffOjtsSearch} />
                  <Route path="/controle/ojt/pendente" component={StaffOjtsSearchToDo} />
                  {/*<Route path="/controle/ojt/realizado" component={StaffOjtsSearchDone} />*/}
                  <Route path="/ojt/cadastrar" component={OjtsAdd} />
                  <Route path="/ojt/:id" component={OjtsEdit} />
                  <Route path="/ojts" component={OjtsIndex} />
                  {/* Plannings */}
                  <Route path="/planejamento/cadastrar" component={PlanningsAdd} />
                  <Route path="/planejamento/ferias/cadastrar" component={PlanningsAddVacations} />
                  <Route path="/confirmar/ferias" component={PlanningVacationStaffsConfirmation} />
                  <Route path="/trocar/ferias" component={PlanningVacationStaffsChange} />
                  <Route path="/planejamentos/ferias" component={PlanningsIndexVacations} />
                  <Route path="/planejamento/ferias/:id" component={PlanningsEditVacations} />
                  <Route path="/planejamento/:id" component={PlanningsEdit} />
                  {/* Posts */}
                  <Route path="/cargo/cadastrar" component={PostsAdd} />
                  <Route path="/cargo/:id" component={PostsEdit} />
                  <Route path="/cargos" component={PostsIndex} />
                  {/* References */}
                  <Route path="/referencia/cadastrar" component={ReferencesAdd} />
                  <Route path="/referencia/:id" component={ReferencesEdit} />
                  <Route path="/referencias" component={ReferencesIndex} />
                  {/* Roles */}
                  <Route path="/regime/cadastrar" component={RegimesAdd} />
                  <Route path="/regime/:id" component={RegimesEdit} />
                  <Route path="/regimes" component={RegimesIndex} />
                  {/* Roles */}
                  <Route path="/funcao/cadastrar" component={RolesAdd} />
                  <Route path="/funcao/:id" component={RolesEdit} />
                  <Route path="/funcoes" component={RolesIndex} />
                  {/* RoleGroupCertifications */}
                  <Route path="/controle/certificados/obrigatorios" component={RoleGroupCertificationsIndex} />
                  {/* Schedules */}
                  <Route path="/escala/cadastrar" component={SchedulesAdd} />
                  <Route path="/escala/simulacao" component={SchedulesChangeSimulation} />
                  <Route path="/escala/elaborar" component={SchedulesElaborate} />
                  <Route path="/escala/editar/:id" component={SchedulesEdit} />
                  <Route path="/escala/duplicar/:id" component={SchedulesDuplicate} />
                  <Route path="/escalas/unificadas/:month/:year" component={SchedulesUnified} />
                  <Route path="/escalas" component={SchedulesIndex} />
                  {/* Pendnecias de escala */}
                  <Route path="/escala/pendencias/abertas" component={SchedulePendenciesPending} />
                  <Route path="/escala/pendencias/resolvidas" component={SchedulePendenciesIndex} />
                  {/* Solicitacoes da escala */}
                  <Route path="/escala/solicitacoes" component={ScheduleRequestsIndex} />

                  {/* ScheduleGrades */}
                  <Route path="/escala/grade/:id" component={ScheduleGradesEdit} />
                  <Route path="/controle/vencimentos/escala" component={ScheduleGradesExpirationsControl} />
                  {/* ScheduleTrades */}
                  <Route path="/solicitacoes/completo" component={ScheduleTradesIndex} />
                  <Route path="/solicitacoes/pendentes" component={ScheduleTradesPending} />
                  <Route path="/solicitacoes/cadastrar" component={ScheduleTradesAdd} />
                  {/* Staffs */}
                  <Route path="/controle/colaboradores/contratacao" component={StaffsWithoutDesignations} />
                  <Route path="/controle/pesquisa/geral" component={StaffsFullSearch} />
                  <Route path="/controle/vencimentos/itens/designacao" component={ExpireItensStaffDesignations} />
                  <Route path="/controle/promocoes" component={StaffsPromotionsIndex} />
                  <Route path="/colaborador/cadastrar" component={StaffsAdd} />
                  <Route path="/colaborador/:id" component={StaffsEdit} />
                  <Route path="/colaboradores/ativos" component={StaffsIndex} />
                  <Route path="/colaboradores/comandantes" component={StaffsIndexCmdts} />
                  <Route path="/colaboradores/todos" component={StaffsIndexFull} />
                  <Route path="/colaboradores/designacoes" component={StaffsByDesignationIndex} />
                  <Route path="/colaboradores/transferidos" component={StaffsIndexTransfered} />
                  <Route path="/colaboradores/contratados" component={StaffsIndexContracted} />
                  <Route path="/colaboradores/demitidos" component={StaffsIndexFired} />
                  <Route path="/controle/cnh" component={StaffsIndexCnh} />
                  {/* StaffFleets */}
                  <Route path="/controle/frotas/obrigatorias/faltantes" component={StaffWithoutFleetsIndex} />
                  <Route path="/controle/aso" component={StaffsIndexAso} />
                  {/* StaffsTaskCards */}
                  <Route path="/colaboradores/task_cards" component={StaffsIndexTaskCards} />
                  <Route path="/controle/colaboradores/task_cards" component={StaffsControlTaskCards} />
                  {/* SuspendedStaffAircraftModels */}
                  <Route path="/colaboradores/frotas/revogadas" component={SuspendedStaffAircraftModels} />
                  {/* StaffFleets */}
                  <Route path="/controle/frotas/obrigatorias" component={StaffFleetsIndex} />
                  {/* StaffAircraftModels */}
                  <Route path="/controle/frotas" component={StaffAircraftModelsIndex} />
                  <Route path="/controle/frotas_sem_certificados" component={StaffAircraftModelsWithoutCertificationsIndex} />
                  {/* StaffBases */}
                  <Route path="/controle/bases" component={StaffBasesIndex} />
                  {/* StaffCertifications */}
                  <Route path="/staff_certifications/:staff_id/:id" component={StaffCertificationsEdit} />
                  <Route path="/controle/certificados/notas" component={StaffCertificationsResults} />
                  <Route path="/controle/certificados/vencimento" component={StaffsCerficationsOutdatedIndex} />
                  <Route path="/controle/certificados/arquivados" component={StaffCertificationsArchiveIndex} />
                  <Route path="/controle/certificados" component={StaffCertificationsIndex} />
                  <Route path="/controle/filtro/certificados" component={StaffsCerficationsMultipleFilter} />
                  <Route path="/controle/treinamentos/funcoes" component={StaffsCerficationsByRolesIndex} />
                  <Route path="/controle/treinamentos/designacoes" component={StaffsCerficationsByDesignationsIndex} />
                  {/* StaffCertifications */}
                  <Route path="/controle/cheques" component={StaffChecksIndex} />

                  {/* StaffDesignations */}
                  <Route path="/controle/designacoes/funcao" component={StaffDesignationsControl} />
                  <Route path="/controle/designacoes/pendentes" component={StaffDesignationsPending} />
                  <Route path="/controle/designacoes" component={StaffDesignationsIndex} />
                  {/* StaffJobTrainings */}
                  <Route path="/controle/ojt/atual" component={StaffOjtsActualSearch} />
                  <Route path="/controle/ojt" component={StaffJobTrainingsIndex} />
                  {/* StaffLicenses */}
                  <Route path="/controle/habilitacoes" component={StaffLicensesIndex} />
                  {/* StaffLanguages */}
                  <Route path="/controle/idiomas" component={StaffLanguagesIndex} />
                  {/* StaffOjts */}
                  <Route path="/funcionario/ojts" component={StaffOjtsEdit} />
                  <Route path="/funcionario/ojt/cadastrar" component={StaffOjtsAdd} />
                  {/* StaffsCerficationsConsolidated */}
                  <Route path="/controle/treinamentos/consolidados" component={StaffCerficationsConsolidated} />
                  {/* StaffRevisions */}
                  <Route path="/controle/revisoes/designacoes" component={StaffRevisionsIndex} />
                  {/* StaffStamps */}
                  <Route path="/controle/carimbos" component={StaffStampsIndex} />
                  {/* Supplier */}
                  <Route path="/fornecedor/cadastrar" component={SuppliersAdd} />
                  <Route path="/fornecedor/editar/:id" component={SuppliersEdit} />
                  <Route path="/fornecedores" component={SuppliersIndex} />
                  {/* Tasks */}
                  <Route path="/tarefa/cadastrar" component={TasksAdd} />
                  <Route path="/tarefa/:id" component={TasksEdit} />
                  <Route path="/tarefas" component={TasksIndex} />
                  {/* Trainings */}
                  <Route path="/treinamento/cadastrar" component={TrainingsAdd} />
                  <Route path="/treinamento/:id" component={TrainingsEdit} />
                  <Route path="/treinamentos" component={TrainingsIndex} />
                  <Route path="/controle/treinamentos/certificado" component={TrainingsByCertificationIndex} />
                  {/* TrainingCertificationStaffs */}
                  <Route path="/controle/treinamentos/nao/finalizados" component={TrainingCertificationStaffControl} />
                  <Route path="/controle/treinamentos/realizados" component={TrainingCertificationStaffsIndex} />
                  <Route path="/controle/treinamentos/previstos" component={TrainingCertificationStaffsIndexExpected} />
                  {/* TrainingCertificationStaffPayments */}
                  <Route path="/pagamento/horas/cadastrar" component={PaymentHoursAdd} />
                  <Route path="/pagamento/diarias/cadastrar" component={PaymentDailyAdd} />
                  <Route path="/pagamento/extra/cadastrar" component={PaymentExtraAdd} />
                  <Route path="/pagamento/diarias/internacional/cadastrar" component={PaymentDailyInternationalAdd} />
                  <Route path="/pagamentos/abertos/horas" component={PaymentHoursOpened} />
                  <Route path="/pagamentos/abertos/diarias" component={PaymentDailyOpened} />
                  <Route path="/pagamentos/abertos/extra" component={PaymentExtraOpened} />
                  <Route path="/cheques/abertos" component={PaymentCheckOpened} />
                  <Route path="/saldo/devedor" component={StaffDebt} />
                  <Route path="/pagamentos/saldo/debito/cadastrar" component={PaymentDebtAdd} />
                  <Route path="/pagamentos/saldo/debito/editar/:id" component={PaymentDebtEdit} />
                  <Route path="/pagamentos/saldo/credito/cadastrar" component={PaymentCreditAdd} />
                  <Route path="/pagamentos/saldo/credito/editar/:id" component={PaymentCreditEdit} />
                  {/* SchedulePayments */}
                  <Route path="/escala/pagamento/horas/cadastrar" component={SchedulePaymentHoursAdd} />
                  <Route path="/escala/pagamento/diarias/cadastrar" component={SchedulePaymentDailyAdd} />
                  <Route path="/escala/pagamento/deslocamento/cadastrar" component={SchedulePaymentDistanceAdd} />
                  <Route path="/escala/pagamento/transporte/cadastrar" component={SchedulePaymentTransportAdd} />
                  <Route path="/escala/pagamento/extra/cadastrar" component={SchedulePaymentExtraAdd} />
                  <Route path="/escala/base/pagamento/diarias/cadastrar" component={SchedulePaymentDailyBaseAdd} />
                  <Route path="/escala/pagamentos/abertos/horas" component={SchedulePaymentHoursOpened} />
                  <Route path="/escala/pagamentos/abertos/diarias" component={SchedulePaymentDailyOpened} />
                  <Route path="/escala/pagamentos/abertos/representante" component={SchedulePaymentBaseChiefOpened} />
                  <Route path="/escala/pagamentos/abertos/deslocamento" component={SchedulePaymentDistanceOpened} />
                  <Route path="/escala/pagamentos/abertos/transporte" component={SchedulePaymentTransportOpened} />
                  <Route path="/escala/pagamentos/abertos/extra" component={SchedulePaymentExtraOpened} />
                  {/* Payments */}
                  <Route path="/lista/solicitacao/pagamento/deslocamento/treinamento" component={PaymentRequestTrainingDistanceIndex} />
                  <Route path="/lista/solicitacao/pagamento/transporte/treinamento" component={PaymentRequestTrainingTransportIndex} />
                  {/* PaymetValues */}
                  <Route path="/pagamento/valores" component={PaymentValuesEdit} />
                  {/* PaymetValues */}
                  <Route path="/ordens/pagamentos/abertas" component={PaymentOrdersOpenedIndex} />
                  <Route path="/ordens/pagamentos/enviadas" component={PaymentOrdersSentIndex} />
                  <Route path="/ordem/pagamento/cadastrar" component={PaymentOrdersAdd} />
                  <Route path="/ordem/pagamento/editar/:id" component={PaymentOrdersEdit} />
                  {/* StaffRevisionDesignations */}
                  <Route path="/revisao/designacao/colaborador/finalizada/:id" component={StaffRevisionDesignationEmail} />
                  <Route path="/revisao/designacao/gestor/corrigida/:id" component={StaffRevisionDesignationRepairEmail} />
                  <Route path="/revisao/designacao/gestor/finalizada/:id" component={StaffRevisionDesignationResponsiblesEmail} />
                  <Route path="/controle/revisao/designacao" component={StaffRevisionDesignationsIndex} />

                  {/* Home */}
                  <Route path="/" component={StaffsIndex} />
                </Switch>
              </BrowserRouter>
            </div>
        }
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js